module.exports = __webpack_public_path__ + "img/list_slide_04.8940565a.jpg";